import { gql } from '@apollo/client'
import { useContext } from 'react'

import { BoxLockContext } from '../context'
import { ModalLock } from '../modal-lock'
import { PaywallLock } from '../paywall-lock'
import {
  TwoOffersSwitchFrequencyLock_OfferLockDataFragment,
  TwoOffersSwitchFrequencyLock_ViewerFragment,
} from './__generated__/two-offers-switch-frequency-lock.graphql'
import styles from './two-offers-switch-frequency-lock.module.scss'
import { TwoOffersSwitchFrequencyLockContent } from './two-offers-switch-frequency-lock-content'

export interface TwoOffersSwitchFrequencyLockProps {
  offerLockData: TwoOffersSwitchFrequencyLock_OfferLockDataFragment
  viewer: TwoOffersSwitchFrequencyLock_ViewerFragment
}

export function TwoOffersSwitchFrequencyLock({
  offerLockData,
  viewer,
}: TwoOffersSwitchFrequencyLockProps) {
  const { componentType } = useContext(BoxLockContext)
  const content = (
    <TwoOffersSwitchFrequencyLockContent viewer={viewer} offerLockData={offerLockData} />
  )

  switch (componentType) {
    case 'paywall':
      return (
        <PaywallLock offerLockData={offerLockData} className={styles['paywall-two-offers-lock']}>
          {content}
        </PaywallLock>
      )
    case 'modal':
      return <ModalLock offerLockBody={offerLockData.body}>{content}</ModalLock>
    default:
      return null
  }
}

TwoOffersSwitchFrequencyLock.fragments = {
  offerLockData: gql`
    fragment TwoOffersSwitchFrequencyLock_offerLockData on OfferLockData {
      ...TwoOffersSwitchFrequencyLockContent_offerLockData
      ...PaywallLock_offerLockData
      body {
        ...ModalLock_offerLockBody
      }
    }
    ${ModalLock.fragments.offerLockBody}
    ${PaywallLock.fragments.offerLockData}
    ${TwoOffersSwitchFrequencyLockContent.fragments.offerLockData}
  `,
  viewer: gql`
    fragment TwoOffersSwitchFrequencyLock_viewer on Profile {
      ...TwoOffersSwitchFrequencyLockContent_viewer
    }
    ${TwoOffersSwitchFrequencyLockContent.fragments.viewer}
  `,
}
